import request from 'utils/request'

/*---------  角色管理    -------*/
//获取角色列表
export const getRollList = () => request().get('role/listRole')
//获取table数据
export const getTableData = data => request().post('role/page', data)
//获取权限级别
export const getPermissionLevels = () =>
  request().get('role/listPermissionLevels')
//获取权限配置
export const getMenuList = () => request().get('menu/list')
//新增角色
export const addRole = data => request().post('role/add', data)
//删除角色
export const deleteRole = id => request().get(`role/delete/${id}`)
